import * as React from 'react';
import ReactDOM from 'react-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import { isKioskOnlyUser } from './appRolesComponents';
import './index.css';

//import registerServiceWorker from './registerServiceWorker';

const App = React.lazy(() => import('./App.jsx'));
const KioskApp = React.lazy(() => import('./KioskApp.jsx'));

const getStoredPermissions = () => {
        try {
                return JSON.parse(localStorage.getItem('permissions')) || [];
        } catch (e) {
                return [];
        }
};

const token = localStorage.getItem('accessToken');
const permissions = getStoredPermissions();

// Sin token: shell liviano (login) para que la tablet no baje el chunk con react-pdf.
// Con token kiosk-only: KioskApp. Resto: App completa.
const useKioskShell = !token || isKioskOnlyUser(permissions);
const Root = useKioskShell ? KioskApp : App;

const LoadingFallback = () => (
        <div
                style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100vh',
                }}
        >
                <CircularProgress />
        </div>
);

ReactDOM.render(
        <React.Suspense fallback={<LoadingFallback />}>
                <Root />
        </React.Suspense>,
        document.getElementById('root')
);

//registerServiceWorker();
